import { useAppDispatch } from "@/app/hooks";
import { disableSubscription, enableSubscription } from "@/features";
import { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

type Props = {
  isOpen: boolean;
  selectedId: number;
  isDisable: boolean;
  onSuccess: () => void;
  toggle: () => void;
};

export const EADisableSubscription = ({
  isOpen,
  selectedId,
  isDisable,
  onSuccess,
  toggle,
}: Props) => {
  const dispatch = useAppDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async () => {
    setIsSubmitting(true);
    try {
      if (isDisable) {
        await dispatch(disableSubscription(selectedId)).unwrap();
      } else {
        await dispatch(enableSubscription(selectedId)).unwrap();
      }
      onSuccess();
      toggle();
    } catch (error) {
      console.log("error: ", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        Confirm {isDisable ? "Disable" : "Enable"}
      </ModalHeader>
      <ModalBody>
        <p>
          Are you sure want to{" "}
          <span className="fw-bold">{isDisable ? "DISABLE" : "ENABLE"}</span>{" "}
          this subscription?
        </p>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={() => toggle()} disabled={isSubmitting}>
          Close
        </Button>
        <Button
          color="primary"
          onClick={() => onSubmit()}
          disabled={isSubmitting}
        >
          Yes
        </Button>
      </ModalFooter>
    </Modal>
  );
};
